<script>
import { mapActions, mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables'; 

export default {
  props: {
    staffId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedSchedule: null,
    };
  },
  computed: {
    ...mapGetters('appointments', ['scheduleList']),
    branchId() {
      return this.$route.params.branchId;
    },
  },
  methods: {
    ...mapActions('appointments', ['fetchScheduleList', 'assignStaffSchedule']),

    async handleAssignSchedule() {
      try {
        await this.assignStaffSchedule({
          staffId: this.staffId,
          payload: { schedule_id: this.selectedSchedule },
        });
        this.$emit('refresh');
        this.$emit('close');
      } catch (err) {
        console.error(err);
        useAlert(err);
      }
    },
  },
  async mounted() {
    try {
      await this.fetchScheduleList(this.branchId);
    } catch (err) {
      console.error(err);
      useAlert(err);
    }
  },
  emits: ['close', 'refresh'],
};
</script>

<template>
  <div class="p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-lg max-w-md w-full mx-auto">
    <label class="block mb-4">
      <select v-model="selectedSchedule">
        <option 
          v-for="schedule in scheduleList" 
          :key="schedule.schedule_id" 
          :value="schedule.schedule_id"
        >
          {{ schedule.name }}
        </option>
      </select>
    </label>

    <button 
      @click="handleAssignSchedule()"
      class="w-full py-2 mt-2 text-white font-medium rounded-md transition 
      bg-woot-600 hover:bg-woot-700 focus:ring-2 focus:ring-woot-400 focus:outline-none"
    >
      {{ $t('BRANCHES.ASSIGN_SCHEDULE_MODAL.ASSIGN') }}
    </button>
  </div>
</template>
